import ApiService from '../services/api';

/**
 * Audit API Service
 * Handles requests to audit/history endpoints
 */
class AuditApiService extends ApiService {
  constructor() {
    super('/api/audit');
  }

  /**
   * Get user timeline (all activities by a user)
   * @param {string} userId - User ID
   * @param {Object} params - Query parameters (from, to, action, entityType, search, limit, offset)
   * @returns {Promise} API response
   */
  async getUserTimeline(userId, params = {}) {
    return await this.get(`/user/${userId}`, params);
  }

  /**
   * Get load history
   * @param {string} loadId - Load ID
   * @param {Object} params - Query parameters (from, to, action, limit, offset)
   * @returns {Promise} API response
   */
  async getLoadHistory(loadId, params = {}) {
    return await this.get(`/load/${loadId}`, params);
  }

  /**
   * Get user history (User entity changes)
   * @param {string} userId - User ID
   * @param {Object} params - Query parameters (from, to, action, limit, offset)
   * @returns {Promise} API response
   */
  async getUserHistory(userId, params = {}) {
    return await this.get(`/user-history/${userId}`, params);
  }
}

export default new AuditApiService();
